const TYPE_TRANSLATIONS: Record<string, string> = {
  demonstrativt: "dem.",
  indefinit: "indef.",
  interrogativt: "interr.",
  personligt: "pers.",
  possessivt: "poss.",
  refleksivt: "refl.",
  relativt: "rel."
};

const DEFAULT_TRANSLATIONS: Record<string, string> = {
  ...TYPE_TRANSLATIONS,

  femininum: "f.",
  maskulinum: "m.",
  neutrum: "itk.",
  utrum: "fk.",

  plural: "pl.",
  pluralis: "pl.",
  singular: "sg.",
  singularis: "sg.",

  "bestemt form": "bf.",
  "definite form": "bf.",

  adjective: "adj.",
  adverb: "adv.",
  article: "art.",
  conjunction: "konj.",
  "infinitive marker": "infinitivmærke",
  interjection: "udråbsord",
  "no classification": "",
  noun: "sb.",
  numeral: "talord",
  "onomatopoeic word": "lydord",
  prefix: "præfiks",
  preposition: "præp.",
  pronoun: "pron.",
  "proper noun": "proprium",
  suffix: "suffiks",
  verb: "vb."
};

const SPECIAL_LANGUAGE_TRANSLATIONS: Record<string, Record<string, string>> = {
  de: {
    neutrum: "n."
  },
  no: {
    neutrum: "n."
  }
};

const SKIPPABLE_LANGUAGE_TRANSLATIONS: Record<string, Record<string, string>> = {
  da: TYPE_TRANSLATIONS,
  no: TYPE_TRANSLATIONS
};

function translatePart(str: string, language: string): string {
  if (SKIPPABLE_LANGUAGE_TRANSLATIONS[language]?.[str]) {
    return str;
  }

  if (SPECIAL_LANGUAGE_TRANSLATIONS[language]?.[str]) {
    return SPECIAL_LANGUAGE_TRANSLATIONS[language][str];
  }

  return DEFAULT_TRANSLATIONS[str] ?? str;
}

export function translate(str: string | null, language: string): string | null {
  if (str === null || str === undefined) {
    return null;
  }

  let splitted = false;
  let translatedStr = str;

  for (const delimiter of ["/", " og "]) {
    if (translatedStr.indexOf(delimiter) === -1) {
      continue;
    }

    translatedStr = translatedStr
      .split(delimiter)
      .map((part) => translatePart(part, language))
      .join(delimiter);

    splitted = true;
  }

  if (splitted) {
    return translatedStr;
  }

  return translatePart(translatedStr, language);
}
